import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMedicationsSearchItemResponse } from '../models';
import { EnvService } from './env.service';
import { HttpWrapperService } from './api';

@Injectable({ providedIn: 'root' })
export class MedicationSearchService {
  constructor(private envService: EnvService, private httpClient: HttpWrapperService) {}

  searchMedications(term: string): Observable<ApiMedicationsSearchItemResponse[]> {
    return this.httpClient.get<ApiMedicationsSearchItemResponse[]>(
      `${this.envService.api.baseUrl}/medications?term=${term}`
    );
  }
}
